<mat-card
  (mouseover)="alert && alert.alarmType !== 'TYPE_FIRE_ALARM' && !crService.nightowlSupervisionPaused(alert) ? alert.showChevron=true : null"
  (mouseout)="alert && alert.alarmType !== 'TYPE_FIRE_ALARM' && !crService.nightowlSupervisionPaused(alert) ? alert.showChevron=false : null"
  [class.mx-2]="!isNightowlVisit"
  [class.my-2]="!isNightowlVisit"
  [class.alertOutOfTime]="alert?.styleOutOfTime"
  [class.alertBadlyOutOfTime]="alert?.styleBadlyOutOfTime"
    [ngStyle]="{'display': isNightowlVisit ? 'initial' : 'flex'
    }"
  (click)="alert && alert.alarmType !== 'TYPE_FIRE_ALARM' && !crService.nightowlSupervisionPaused(alert) ? alert.showChevron ? crService.takeAction(alert) : null : null">
  @if (isNightowlVisit) {
    <mat-card-content
      [ngTemplateOutlet]="nightowlVisit"
      [ngTemplateOutletContext]="{ alert: alert }"
      >
    </mat-card-content>
  }
  @if (!isNightowlVisit) {
    <mat-card-content
      [ngClass]="{'alertCardHeaderWithDrag': $safeNavigationMigration(alert?.allowTransition), 'alertCardTransitional': $safeNavigationMigration(alert?.transitional) }"
      cdkDragHandle>
      @if (alert) {
        <div class="d-flex flex-wrap justify-content-between">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <i
                class="faIconSize {{alert.iconResponse?.iconClass}}"
                [style.color]="alert?.styleBadlyOutOfTime ? 'inherit' : alert.iconResponse?.color"
              ></i>
              @if (alert.customerName) {
                <span class="ml-2 customerName">
                  {{alert.customerName}}
                </span>
              }
              @if (alert.increment > 0) {
                <span
                  class="ml-3 badge badge-pill badge-danger">
                  {{'+' + alert.increment}}
                </span>
              }
            </div>
            <div class="mt-2">
              <p class="alertHeader ml-2"><strong>{{alert.header}} ({{alert.productId}})</strong></p>
              <p class="ml-2"><small>{{ alert | pickUpActivationName }}</small></p>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="mr-sm-4 my-2">
              <p class="time"><strong>{{ alert.showTime | date: 'mm:ss'}}</strong></p>
            </div>
            <div class="constantWidth">
              @if (alert.showChevron && alert.alarmType !== 'TYPE_FIRE_ALARM') {
                <i class="fa-duotone fa-chevron-right"></i>
              }
            </div>
          </div>
        </div>
      }
    </mat-card-content>
  }
</mat-card>


<ng-template
  #nightowlVisit
  let_alert="alert"
  >
  <mat-card-content
    [ngStyle]="{'padding': '0 0 8px 0', 'background': '#transparent', 'margin-right': '0.5rem'}"
    >

    <div
      class="alertCard"
      [class.alertBadlyOutOfTime]="calculateRemainingTime(alert) < 0"
      [class.alertOutOfTime]="calculateRemainingTime(alert) > 0 && calculateRemainingTime(alert) < 60"
      >
      <div
        class="alertCardHeader noBorder cursorPointer"
        [ngStyle]="{'padding': '0.5rem'}"
        >
        <div class="d-flex flex-wrap justify-content-between">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <i
                class="faIconSize {{alert.iconResponse?.iconClass}}"
                [style.color]="alert?.styleBadlyOutOfTime ? 'inherit' : alert.iconResponse?.color"
              ></i>

              @if (alert.customerName) {
                <div
                  class="ml-2 customerName"
                  >
                  {{alert.customerName}}
                </div>
              }
            </div>
            <div class="mt-2">
              <p class="alertHeader" [ngStyle]="{'margin-bottom': '0px'}"><strong>{{alert.header}} ({{alert.productId}})</strong></p>
            </div>
          </div>
          <div class="d-flex align-items-center border-left">
            <div class="mr-sm-4 my-2 pl-3">
              <p [ngStyle]="{'margin-bottom': '0px'}"><small>{{'TIME_REMAINING' |translate}}</small></p>
              <p [ngStyle]="{'margin-bottom': '0px'}"><strong>{{crService.getFormattedRemainingTime(calculateRemainingTime(alert))}}</strong></p>
            </div>
            <div class="constantWidth">
              <i class="fa-duotone fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>

</ng-template>
